import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const ITEM_PATH = "/item/v1";

export const getItemApi = async (params, options = {}) => await getRequest(ITEM_PATH, params, options);
export const getMedicinesApi = async (params, options = {}) => await getRequest(`${ITEM_PATH}/medicines`, params, options);

export const getItemByIdApi = async (params, options = {}) => await getRequest(`${ITEM_PATH}/${params?.id}`);

export const addItemApi = async (body) => await postRequest(ITEM_PATH, body);

export const updateItemApi = async (body) =>
  await putRequest(`${ITEM_PATH}/${body?._id}`, body);

export const deleteItemByIdApi = async (id) =>
  await deleteRequest(`${ITEM_PATH}/${id}`);
